import { render, staticRenderFns } from "./AuctionItem.vue?vue&type=template&id=6153f2fa&scoped=true"
import script from "./AuctionItem.vue?vue&type=script&lang=js"
export * from "./AuctionItem.vue?vue&type=script&lang=js"
import style0 from "./AuctionItem.vue?vue&type=style&index=0&id=6153f2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6153f2fa",
  null
  
)

export default component.exports